<template>
    <Form @submit="submit" v-slot="{ errors }" :initial-values="{ad: initialValues}" :validation-schema="schema" class="row">
        <div class="col-12 mt-3">
            <div class="form-floating">
                <Field id="ad.title" name="ad.title" class="form-control" :class="{'is-invalid': errors['ad.title']}" />
                <label for="ad.title">Titel</label>
                <div v-if="errors['ad.title']" class="invalid-feedback">
                    {{  errors['ad.title'] }}
                </div>
            </div>
        </div>
        <div class="col-12 mt-3">
            <div class="form-floating">
                <Field id="ad.link" name="ad.link" class="form-control" :class="{'is-invalid': errors['ad.link']}" />
                <label for="ad.link">Link</label>
                <div v-if="errors['ad.link']" class="invalid-feedback">
                    {{  errors['ad.link'] }}
                </div>
            </div>
        </div>
        <div class="col-12 mt-3">
            <div style="border: 1px solid black;" class="p-2 mb-3" v-if="initialValues?.file_link">
                Aktuelles Bild<span style="color: red;"> (wird mit neuer Datei überschrieben!)</span>
                <img class="img-fluid" :src="initialValues.file_link" />
                <Field type="hidden" name="ad.file_link"></Field>
            </div>
            <Field name="ad.file" v-slot="{ handleChange, handleBlur }">
                <DropZone ref="dropzone"
                          :mediaLibraryMode="false"
                          text=""
                          @change="handleChange"
                          @onDrop="handleChange"
                          @blur="handleBlur"
                          :class="{'is-invalid': errors['ad.file']}"
                />
            </Field>
            <div v-if="errors['ad.file']" class="invalid-feedback">
                {{  errors['ad.file'] }}
            </div>
        </div>
        <div class="col-12 col-lg-6 mt-3">
            <div class="form-floating">
                <Field id="ad.custom_color" name="ad.custom_color" class="form-control" :class="{'is-invalid': errors['ad.custom_color']}" />
                <label for="ad.custom_color">Custom Color (färbt Titel und Button)</label>
                <div v-if="errors['ad.custom_color']" class="invalid-feedback">
                    {{  errors['ad.custom_color'] }}
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-6 mt-3">
            <div class="form-floating">
                <Field id="ad.button_text" name="ad.button_text" class="form-control" :class="{'is-invalid': errors['ad.button_text']}" />
                <label for="ad.button_text">Button Text</label>
                <div v-if="errors['ad.button_text']" class="invalid-feedback">
                    {{  errors['ad.button_text'] }}
                </div>
            </div>
        </div>
        <div class="col-12 mt-3">
            <div class="form-floating">
                <Field id="ad.content" as="textarea" name="ad.content" class="form-control" :class="{'is-invalid': errors['ad.content']}" />
                <label for="ad.content">Inhalt (Html)</label>
                <div v-if="errors['ad.content']" class="invalid-feedback">
                    {{  errors['ad.content'] }}
                </div>
            </div>
        </div>
        <div class="col-12 mt-3">
            <button class="btn btn-success" type="submit">Speichern</button>
        </div>
    </Form>

</template>
<script>
import Yup from '@/yup'
import DropZone from "@/components/general/DropZone.vue";
import {Field, Form} from "vee-validate";

export default {
    name: "AdForm",
    data() {
        return {
            schema: Yup.object().shape({
                ad: Yup.object().shape({
                    title: Yup.string().required(),
                    file: Yup.array().when('file_link', (file_link, schema) => {
                        if (file_link === undefined) {
                            return schema.required()
                        }
                        return schema.nullable()
                    }
                    ),
                    link: Yup.string().required(),
                }),
            }),
        }
    },
    props: {
        initialValues: {
            default: () => {},
            type: Object
        }
    },
    components: {
        Field,
        Form,
        DropZone
    },
    methods: {
        submit(values) {
            this.$emit('submitted', values);
        },
    }
}
</script>
